import { useEffect, useMemo } from 'react';

import { EventData } from '../types';
import { IdParamsType } from 'utils/types';
import { camelize } from 'utils/utils';
import { getData } from 'services/api';
import { setLastEvent } from 'store/slices/lastEventSlice';
import { useAppDispatch } from 'store/hooks';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

const useGetEvent = (id?: number) => {
	const { id: eventId }: IdParamsType = useParams();
	const dispatch = useAppDispatch();

	const { data: rawEvent, isError } = useQuery({
		queryKey: ['event', eventId || id],
		queryFn: (): Promise<EventData> => getData(`events/${eventId || id}`),
		enabled: !!eventId || !!id,
	});

	const event = useMemo<EventData | null>(() => {
		if (!rawEvent) return null;
		const camelized = camelize(rawEvent) as EventData;
		const ticketTypes = camelized.ticketTypes.map((ticket) => ({
			...ticket,
			quantity: 0,
			priceWithNoDiscount: ticket.initialPrice,
			promoCodeApplied: false,
		}));
		return { ...camelized, ticketTypes };
	}, [rawEvent]);

	useEffect(() => {
		if (event) {
			dispatch(setLastEvent(event));
		}
	}, [event, dispatch]);

	return { event, isError };
};

export default useGetEvent;
